import script from "./UiButton.vue?vue&type=script&setup=true&lang=js"
export * from "./UiButton.vue?vue&type=script&setup=true&lang=js"

import "./UiButton.vue?vue&type=style&index=0&id=8adec0d0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8adec0d0"]])

export default __exports__